module.exports = __webpack_public_path__ + "sprstatic/img/xin (3).8d89b45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xin/xin (3).png
// module id = X6Jq
// module chunks = 2